module.exports = __webpack_public_path__ + "static/media/icSkyminer.e48d3c77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Ecosystem/images/icSkyminer.svg
// module id = 903
// module chunks = 0